import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorReporting } from './lib/errorReporter';

// Daily hard-refresh on first open of the day — pulls latest hashed bundles after deploys.
// Must run before anything else so we short-circuit before mounting React.
try {
  const today = new Date().toISOString().slice(0, 10);
  const last = localStorage.getItem('lastRefreshDate');
  if (last && last !== today) {
    localStorage.setItem('lastRefreshDate', today);
    window.location.reload();
    throw new Error('reloading'); // halt further module execution
  }
  if (!last) localStorage.setItem('lastRefreshDate', today);
} catch (e) {
  if (e && e.message === 'reloading') throw e;
  // localStorage unavailable (private mode, etc.) — just skip.
}

// React 19 removed unstable_batchedUpdates but @dnd-kit/core still calls it.
// Shim it as a passthrough — React 18+ batches updates automatically anyway.
if (!ReactDOM.unstable_batchedUpdates) {
  ReactDOM.unstable_batchedUpdates = (fn) => fn();
}

// Capture PWA install prompt globally BEFORE React mounts.
// beforeinstallprompt fires once on page load — if no listener catches it, it's lost.
// Layout.js only mounts after login, so it would miss the event.
window.__deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
});

// Prevent browser-level pinch-to-zoom globally on the PWA.
// Safari uses gesture* events; Chrome/Android is handled via CSS touch-action.
// PinchZoomImage components override touch-action locally for their own pinch gestures.
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('gesturechange', (e) => e.preventDefault());
document.addEventListener('gestureend', (e) => e.preventDefault());

const root = ReactDOM.createRoot(document.getElementById("root"));
installGlobalErrorReporting();
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
